// extracted by mini-css-extract-plugin
export default {"wrapper":"Sj","form":"Tj","checkbox":"Uj","successWrapper":"Vj","success":"Wj","successText":"Xj","circle":"Yj","footnote":"Zj","required":"_j"};